export const btnSty = {
    paddingY: 2,
    paddingX: 4,
    fontFamily: "DM Sans",
    fontWeight: 700,
    fontSize: "12px",
    borderRadius: "12px",
  };
  